<footer class="footer">
  <div class="footer-content">
    <div class="footer-brand">
      <img src="logo-wide-inverted.svg" alt="BOLOARENA" class="footer-logo" loading="lazy" decoding="async">
      <p class="tagline">Your ultimate tournament management platform.</p>
    </div>

    <div class="footer-links">
      <div class="link-group">
        <h3>Company</h3>
        <a routerLink="/" routerLinkActive="active">Home</a>
        <a routerLink="/tournaments" routerLinkActive="active">Tournaments</a>
        <a routerLink="/leagues" routerLinkActive="active">Leagues</a>
      </div>

      <div class="link-group">
        <h3>Legal</h3>
        <a routerLink="/terms" routerLinkActive="active">Terms & Conditions</a>
        <a routerLink="/privacy" routerLinkActive="active">Privacy Policy</a>
        <a routerLink="/cookie-policy" routerLinkActive="active">Cookie Policy</a>
      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <p>&copy; {{ currentYear }} BOLOARENA. All rights reserved.</p>
  </div>
</footer>
